import { STEPS } from "../constants";
import { Reveal } from "./Reveal";

const HowItWorks = () => (
    <section id="how-it-works" className="py-16 sm:py-24 lg:py-32 bg-[#0F172A] relative overflow-hidden grain" data-testid="how-it-works-section">
        <div
            className="pointer-events-none absolute -top-40 right-0 w-[34rem] h-[34rem] rounded-full"
            style={{ background: "radial-gradient(circle, rgba(11,92,245,0.25), transparent 65%)" }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            <Reveal>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#7DA8FF] mb-4">How it works</p>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="font-display font-medium text-white text-2xl sm:text-3xl lg:text-4xl tracking-tight max-w-2xl leading-[1.1]">
                    Four steps to a <span className="italic text-[#38BDF8]">lighter day.</span>
                </h2>
            </Reveal>
            <Reveal delay={0.16}>
                <p className="mt-5 text-base sm:text-lg text-slate-400 max-w-2xl leading-relaxed">
                    Honest status at every step — a helper is only ever shown as confirmed after they accept
                    your request.
                </p>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {STEPS.map((s, i) => (
                    <Reveal key={s.step} delay={i * 0.12}>
                        <div
                            className="group relative h-full rounded-3xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-7 transition-all duration-300 hover:bg-white/[0.08] hover:border-[#38BDF8]/40 hover:-translate-y-1.5"
                            data-testid={`how-it-works-step-${i + 1}`}
                        >
                            <span className="font-display text-5xl font-semibold text-[#0B5CF5] group-hover:text-[#38BDF8] transition-colors duration-300">
                                {s.step}
                            </span>
                            <h3 className="mt-5 text-lg font-bold text-white tracking-tight">{s.title}</h3>
                            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
                            {i < STEPS.length - 1 && (
                                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-px bg-gradient-to-r from-[#38BDF8]/60 to-transparent" />
                            )}
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default HowItWorks;
